import { GridApi, GridCsvExportOptions } from '@mui/x-data-grid-pro';
import { parse } from 'papaparse';

interface AccountingExportParams {
	apiRef: React.MutableRefObject<GridApi>;
	exportHeaders: string[];
	options?: GridCsvExportOptions;
}

export const exportAccountingTable = (data: AccountingExportParams) => {
	const { options } = data;
	const csvStringData = getCsvDataWithHeaderRow(data);
	exportDataAsCsv(csvStringData, options);
};

const getCsvDataWithHeaderRow = (data: AccountingExportParams) => {
	const { apiRef, options, exportHeaders } = data;
	const inventoryDataCsvString = apiRef.current.getDataAsCsv(options);
	const parsedFirstRowCsvData = parse<string>(inventoryDataCsvString, { preview: 1, header: true });
	const newline = parsedFirstRowCsvData.meta.linebreak;
	const headerRowStrings = exportHeaders.join(newline);
	const newCsvString = headerRowStrings + newline + newline + inventoryDataCsvString;
	return newCsvString;
};

// Custom csv download implementation, following the same behaviour that MUI library uses
// https://github.com/mui-org/material-ui-x/blob/e45cf31723303ccc20cf21cccb6ef1e975364bed/packages/grid/_modules_/grid/hooks/features/export/useGridCsvExport.tsx
// https://github.com/mui-org/material-ui-x/blob/e45cf31723303ccc20cf21cccb6ef1e975364bed/packages/grid/_modules_/grid/utils/exportAs.ts
const exportDataAsCsv = (csv: string, options?: GridCsvExportOptions): void => {
	const blob = new Blob([options?.utf8WithBom ? new Uint8Array([0xef, 0xbb, 0xbf]) : '', csv], {
		type: 'text/csv',
	});
	const fileName = options?.fileName ?? document.title;
	const fullName = `${fileName}.csv`;
	if ('download' in HTMLAnchorElement.prototype) {
		const url = URL.createObjectURL(blob);
		const a = document.createElement('a');
		a.href = url;
		a.download = fullName;
		a.click();
		setTimeout(() => {
			URL.revokeObjectURL(url);
		});
		return;
	}
	throw new Error('Error exporting .csv');
};
